
    <div class="patient-list">
      <table class="patient-table" mat-table [dataSource]="getBuildingUnits()" matSort (matSortChange)="changeSort($event)">
        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit </th>
          <td mat-cell  *matCellDef="let unit">{{formatFloorUnit(unit.identifier)}} </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
          <td mat-cell *matCellDef="let unit">  {{unit.status}} </td>
        </ng-container>
        <ng-container matColumnDef="reportedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Reported By </th>
          <td mat-cell  *matCellDef="let unit"> {{unit.reportedBy}} </td>
        </ng-container>
        <ng-container matColumnDef="reportedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Reported At </th>
          <td mat-cell  *matCellDef="let unit"> {{getReportedAt(unit.reportedAt)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
      </table>
      </div>
